/* eslint-disable react/prop-types */
import React from "react";
import { Helmet } from "react-helmet";
import theme from "../../../../_theme";

const SEOHead = ({
  title,
  description,
  themeColor = theme.palette.primary.main,
}) => (
  <Helmet>
    <title>{title}</title>
    {/* Theme color for most modern browsers */}
    <meta name="theme-color" content={themeColor} />

    {/* Fallback for older versions of Microsoft Edge and Internet Explorer */}
    <meta name="msapplication-TileColor" content={themeColor} />
    <meta name="msapplication-navbutton-color" content={themeColor} />

    {/* Apple devices (Safari) */}
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="mobile-web-app-status-bar-style" content={themeColor} />

    {/* Android Chrome */}
    <meta
      name="theme-color"
      content={themeColor}
      media="(prefers-color-scheme: light)"
    />
    <meta
      name="theme-color"
      content={themeColor}
      media="(prefers-color-scheme: dark)"
    />

    <meta name="viewport" content="initial-scale=1.0, width=device-width" />
    <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    ></link>
    <meta name="description" content={description} />
  </Helmet>
);

export default SEOHead;
